export default __webpack_public_path__ + "static/media/Edge of the Ubah Kan.9c914ea2.jpg";